import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <meta name='author' content='חושבים פלוס' />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content='website' />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'חושבים פלוס - משחקי חשיבה ואסטרטגיה לילדים',
  description: 'חושבים פלוס - החנות המובילה למשחקי חשיבה, אסטרטגיה וגיבוש לילדים. משחקים איכותיים לפיתוח חשיבה יצירתית',
  keywords: 'חושבים פלוס, משחקים לילדים, משחקי חשיבה, משחקי אסטרטגיה, משחקי גיבוש, משחקי לוח, חנות משחקים',
};

export default Meta;